export default (Vue) => {
    /* Authentication on app */
    Vue.auth = {
        // Set token and expiration from api
        setToken(token, expiration) {
            window.localStorage.setItem('token_amol', token);
            window.localStorage.setItem('expiration_amol', expiration);
        },
        // Set parent if user is subordinate
        setParent(parent){
            window.localStorage.setItem('parent_amol', parent);
        },
        // Get Parent
        getParent(){
            let parent = window.localStorage.getItem('parent_amol');
            if(!parent || ! parent)
            {
                return null;
            }
            return parent;
        },
        // Get Token
        getToken() {
            let token = window.localStorage.getItem('token_amol');
            let expiration = window.localStorage.getItem('expiration_amol');
            if(!token || ! expiration)
            {
                return null;
            }
            if( (Date.now()/1000) > parseInt(expiration))
            {
                this.destroyToken();
                return null;
            }
            return token;
        },
        // Logout app
        destroyToken() {
            window.localStorage.removeItem('token_amol');
            window.localStorage.removeItem('expiration_amol');
            window.localStorage.removeItem('parent_amol');
        },
        // Validate authentication
        isAuthenticated(){
            if(this.getToken())
            {
                return  true;
            }
            return false;
        }
    }

    Object.defineProperties(Vue.prototype, {
        $auth: {
            get: () => {
                return Vue.auth
            }
        }
    });
}


// WEBPACK FOOTER //
// ./src/packages/auth/Auth.js